import React from 'react';
import styled from '../../styles/styled-components';
import { List, ListItem } from '../list';

type MenuProps = {
  divided?: boolean;
  horizontal?: boolean;
};

export const Menu: React.SFC<MenuProps> = ({ ...rest }) => (
  <MenuList {...rest} />
);

Menu.defaultProps = {
  divided: true,
};

const MenuList = styled(List)``;

export const MenuItem = styled(ListItem)`
  padding: 0;
`;
